import { useCallback } from 'react';

import { type SubscriptionPlan } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackViewedCheckoutPage.meta';

export type UseTrackViewedCheckoutPageParams = {
  mode: 'purchase' | 'plan-upgrade' | 'credit-pack-upgrade';
  plan: SubscriptionPlan;
  new_plan?: SubscriptionPlan;
  pack_quantity?: number;
};

export const useTrackViewedCheckoutPage = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedCheckoutPage = useCallback(
    (params: UseTrackViewedCheckoutPageParams) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackViewedCheckoutPage };
};
